import classnames from 'classnames';
import Button from 'components/Button';
import renderField from 'components/Field/reduxForm';
import { noop } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Field, formValueSelector, reduxForm } from 'redux-form/immutable';
import submitFunc from './submitChangePassword';

const formName = 'changePassword';
const passwordMinLength = 7;
const select = formValueSelector(formName);

@connect((state) => ({
  password: select(state, 'newPassword1'),
}))
class ChangePasswordForm extends React.Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitSucceeded: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
    password: PropTypes.string.isRequired,
    showInfoMessage: PropTypes.func.isRequired,
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.submitSucceeded) {
      this.props.showInfoMessage('Пароль успешно изменен');
    }
  }

  getValidationFlags = () => {
    const password = this.props.password || '';

    return {
      invalidLength: password.length < passwordMinLength,
      noCaps: password.search(/[A-Z]/) === -1,
      noLowers: password.search(/[a-z]/) === -1,
      noDigital: password.search(/[0-9]/) === -1,
      noSymbols: password.search(/[#$^&*_\-+%@]/) === -1,
    };
  };

  render() {
    const { handleSubmit, submitting } = this.props;
    const validationFlags = this.getValidationFlags();

    return (
      <div>
        <div className="link link_attention-red">
          ВНИМАНИЕ! Новый пароль обязательно должен содержать:
        </div>
        <ul className="list list__dark profile_list">
          <li className={classnames({ red: validationFlags.invalidLength })}>
            Не менее 7 символов
          </li>
          <li className={classnames({ red: validationFlags.noCaps })}>
            Прописные латинские буквы (A-Z)
          </li>
          <li className={classnames({ red: validationFlags.noLowers })}>
            Строчные латинские буквы (a-z)
          </li>
          <li className={classnames({ red: validationFlags.noDigital })}>Арабские цифры (0-9)</li>
          <li className={classnames({ red: validationFlags.noSymbols })}>
            Спецсимволы (#,$,^,&,*,_,-,+,%,@)
          </li>
        </ul>
        <form onSubmit={handleSubmit}>
          <div className="cRow cRow__mobile cRow__tablet-portrait">
            <div className="cCol cCol__33">
              <Field name="newPassword1" component={renderField} label="Пароль" type="password" />
            </div>
            <div className="cCol cCol__33">
              <Field
                name="newPassword2"
                component={renderField}
                label="Пароль повторно (для контроля)"
                type="password"
              />
            </div>
            <Field name="token" component="input" type="hidden" />
          </div>
          <div className="cRow cRow__mobile cRow__tablet-portrait">
            <div className="cCol cCol__33">
              <div className="form_item">
                <Button isDisabled={submitting} onClick={noop} type="submit">
                  Сохранить пароль
                </Button>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default reduxForm({
  form: formName,
  onSubmit: submitFunc,
})(ChangePasswordForm);
